import { Injectable } from '@angular/core';
import { TechnicalService } from 'app/shared/api/technical-data/api/technical.service';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import { EnvironmentService } from './env.service';
import {
  CommuneTO, ControlCabinetTechnicalData,
  GeoLocationResponseV2ControlCabinetLocationDataV2,
  GeoLocationResponseV2LightingPointLocationDataV2, LightingPointTechnicalData,
  LuxdataService,
} from '../../api/generated/v2/incident';
@Injectable({
  providedIn: 'root'
})
export class LuxDataTechnicalService {

  constructor(private technicalService: TechnicalService,
              private luxDataService: LuxdataService) {
    this.technicalService.configuration.basePath = EnvironmentService.getEnvironment().incidentService;
    this.luxDataService.configuration.basePath = EnvironmentService.getEnvironment().lionBasePath;
  }

  public getLightpointDataById(lightPointNo: string): Observable<LightingPointTechnicalData> {
    return this.technicalService
      .findTechnicalLightpointByLightingNo(lightPointNo, v4(), EnvironmentService.getEnvironment(). name);
  }

  public getControlCabinetDataById(controlCabinetNo: string): Observable<ControlCabinetTechnicalData> {
    return this.technicalService
      .findTechnicalControlCabinetByControlCabinetNo(controlCabinetNo, v4(), EnvironmentService.getEnvironment().name);
  }

  public getCommune(params: any): Observable<CommuneTO[]> {
    return this.technicalService
      .findCommune(params, v4(), EnvironmentService.getEnvironment(). name);
  }

  public getLightpointsByCustomerScope(customerScope: any, lightingNo?: string): Observable<GeoLocationResponseV2LightingPointLocationDataV2> {
    return this.luxDataService
      .getLightingPointsGeoLocationsV2(customerScope, lightingNo);
  }

  // tslint:disable-next-line:max-line-length
  public getLightpointsByCustomerScopeV2(customerScope: any, lightingNo?: string): Observable<GeoLocationResponseV2LightingPointLocationDataV2> {
    return this.luxDataService.getLightingPointsGeoLocationsV2(customerScope, lightingNo);
  }

  /**
   * Retrieves lighting points within a specified bounding box via the `/v2/lightingpoints/by-bounds` API.
   *
   * Performance optimization for big communes (Ticket 5576273): retrieves at most 1,000 points
   * within the map viewport instead of downloading the entire commune upfront.
   *
   * @param customerScope - AGS customer scope identifier (e.g. "AGS_08116033")
   * @param swLat - South-west corner latitude (WGS84)
   * @param swLon - South-west corner longitude (WGS84)
   * @param neLat - North-east corner latitude (WGS84)
   * @param neLon - North-east corner longitude (WGS84)
   * @param lightingNo - Optional lighting point technical number filter
   * @returns Observable resolving to GeoLocationResponse containing points and metadata
   */
  // tslint:disable-next-line:max-line-length
  public getLightpointsByBounds(customerScope: string, swLat: number, swLon: number, neLat: number, neLon: number, lightingNo?: string): Observable<GeoLocationResponseV2LightingPointLocationDataV2> {
    return this.luxDataService.getLightingPointsGeoLocationsByBoundsV2(
      undefined,
      undefined,
      customerScope,
      lightingNo,
      neLat,
      neLon,
      swLat,
      swLon
    );
  }

  // tslint:disable-next-line:max-line-length
 public getControlCabinetByCustomerScope(customerScope: any, cabinetNo?: string): Observable<GeoLocationResponseV2ControlCabinetLocationDataV2> {
    return this.luxDataService
      .getControlCabinetGeoLocationsV2(customerScope, cabinetNo);
  }

  // tslint:disable-next-line:max-line-length
  public getControlCabinetGeolocation(customerScope: any, controlCabinetNo?: any): Observable<GeoLocationResponseV2ControlCabinetLocationDataV2> {
    return this.luxDataService
      .getControlCabinetGeoLocationsV2(customerScope, controlCabinetNo);
  }
}
